<template>
  <div class="patient_info_sections">
    <div class="title no-drag">
      {{ $t('patient.info.info') }}
    </div>
    <div
        v-if="patientProps.check"
        class="right_btn_container"
    >
      <div v-if="patientInfoSection===0" class="right_edit_btn pointer right_btn"
           @click="editPatientInfo()">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('status.edit')"
             width="24" height="24"
             viewBox="0 0 172 172"
             style=" fill:#b1b1b1;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
             stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
             font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#275cbb">
              <path
                d="M43,14.33333c-7.88333,0 -14.33333,6.45 -14.33333,14.33333v114.66667c0,7.88333 6.45,14.33333 14.33333,14.33333h80.0651l-14.33333,-14.33333h-65.73177v-114.66667h50.16667v35.83333h35.83333v29.89844l14.33333,14.33333v-51.39844l-43,-43zM107.5,107.5v14.33333l36.88314,36.88314l14.33333,-14.33333l-36.88314,-36.88314zM163.78353,149.4502l-14.33333,14.33333l7.16667,7.16667c1.3975,1.3975 3.66956,1.3975 5.06706,0l9.26628,-9.26628c1.3975,-1.40467 1.3975,-3.66956 0,-5.06706z"></path>
            </g>
          </g>
        </svg>
      </div>
      <div v-if="patientInfoSection===1" class="right_save_btn pointer right_btn"
           @click="$modal.show('yes-or-no-modal', {questionType:'save', function: checkValidation})">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('status.save')"
             width="24" height="24"
             viewBox="0 0 172 172"
             style=" fill:#000000;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
             stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
             font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#275cbb">
              <path
                d="M34.4,22.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v103.2c0,6.33533 5.13133,11.46667 11.46667,11.46667h103.2c6.33533,0 11.46667,-5.13133 11.46667,-11.46667v-91.73333l-22.93333,-22.93333h-11.46667v34.4c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-51.6c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333v-34.4zM91.73333,22.93333v28.66667h11.46667v-28.66667zM57.33333,91.73333h57.33333c6.33533,0 11.46667,5.13133 11.46667,11.46667v34.4h-80.26667v-34.4c0,-6.33533 5.13133,-11.46667 11.46667,-11.46667z"></path>
            </g>
          </g>
        </svg>
      </div>
      <div v-if="patientInfoSection===1" class="right_cancel_btn pointer right_btn"
           @click="cancelEditPatientInfo()">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('status.cancel')"
             width="19" height="19"
             viewBox="0 0 172 172"
             style=" fill:#000000; margin-top:1px;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
             stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
             font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g id="original-icon" fill="#275cbb">
              <path
                d="M50.16667,13.4375l-50.16667,36.72917l50.16667,36.72917v-22.39583h57.33333c19.96028,0 35.83333,15.87305 35.83333,35.83333c0,19.96028 -15.87305,35.83333 -35.83333,35.83333h-107.5v28.66667h107.5c35.44141,0 64.5,-29.05859 64.5,-64.5c0,-35.4414 -29.05859,-64.5 -64.5,-64.5h-57.33333z"></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <PatientInfoView v-if="patientInfoSection===0"
                     :patientProps="patientInfo"/>
    <PatientInfoModify v-if="patientInfoSection===1"
                       :modifyPatientProps="modifiablePatientInfo"
                       ref="patientInfoModify"/>
  </div>
</template>
<script>
    import PatientInfoView from './view/index'
    import PatientInfoModify from './modify/index'
    import _API from '@/api'
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: `PatientInfoSection`,
        components: { PatientInfoView, PatientInfoModify },
        props: [ 'patientProps' ],
        data() {
            let data = Object.assign( {}, data, this.patientProps );
            let patientStatus = {}, patientInfo = {};
            data.patientStatus = Object.assign( {}, patientStatus, this.patientProps.patientStatus );
            data.patientInfo = Object.assign( {}, patientInfo, this.patientProps.patientInfo );
            return {
                patientInfoSection: 0,
                patientInfo: data,
                modifiablePatientInfo: JSON.parse(JSON.stringify(data)),
            }
        },
        methods: {
            ...mapGetters( [ 'getSeqPatient' ] ),
            ...mapActions( [ 'deletePatientFromPatientList', 'getPatientBySeqPatientFromPatientListNoPromise', 'modifyPatientInfo' ] ),
            resetModifyPatientInfo() {
                this.modifiablePatientInfo = JSON.parse(JSON.stringify(this.patientInfo));
            },
            resetPatientInfo() {
                let data = {};
                data = Object.assign( {}, data, this.patientProps );
                let patientStatus = {}, patientInfo = {};
                data.patientStatus = Object.assign( {}, patientStatus, this.patientProps.patientStatus );
                data.patientInfo = Object.assign( {}, patientInfo, this.patientProps.patientInfo );
                this.patientInfo = data;
            },
            async checkValidation() {
              await this.$refs.patientInfoModify.getValue();

              if (this.modifiablePatientInfo.patientInfo.patientInfoName === "") {
                this.$modal.show('common-alert-modal',{
                  messageType: 'short',
                  message: 'alert.name_value_required'
                });
                return
              }
              if (this.modifiablePatientInfo.patientInfo.patientInfoHeight < 0 || this.modifiablePatientInfo.patientInfo.patientInfoHeight.toString().includes('e')) {
                  this.$modal.show('common-alert-modal',{
                    messageType: 'short',
                    message: 'alert.wrong_value_for_height'
                  });
                return
              }
              if (this.modifiablePatientInfo.patientInfo.patientInfoWeight < 0 || this.modifiablePatientInfo.patientInfo.patientInfoWeight.toString().includes('e')) {
                  this.$modal.show('common-alert-modal',{
                    messageType: 'short',
                    message: 'alert.wrong_value_for_weight'
                  });
                return
              }

              const data = {
                seqPatient : this.modifiablePatientInfo.seqPatient,
                patientEmail : this.modifiablePatientInfo.patientEmail,
                patientInfo : this.modifiablePatientInfo.patientInfo,
              };

              this.savePatientInfo(data);
            },
            savePatientInfo(data) {
              return new Promise( ( resolve, reject ) => {
                  _API.PATIENT.updatePatientInfo( data )
                      .then( res => {
                          if ( res.data.isSuccess ) {
                              this.patientProps.patientInfo.patientInfoName = this.modifiablePatientInfo.patientInfo.patientInfoName;
                              this.patientProps.patientInfo.patientInfoGender = this.modifiablePatientInfo.patientInfo.patientInfoGender;
                              this.patientProps.patientInfo.patientInfoBirth = this.modifiablePatientInfo.patientInfo.patientInfoBirth
                              this.patientProps.patientInfo.patientInfoImageUrl = this.modifiablePatientInfo.patientInfo.patientInfoImageUrl;
                              this.patientProps.patientInfo.patientInfoHeight = this.modifiablePatientInfo.patientInfo.patientInfoHeight;
                              this.patientProps.patientInfo.patientInfoWeight = this.modifiablePatientInfo.patientInfo.patientInfoWeight;
                              this.patientProps.patientInfo.patientInfoPrimaryDiagnosis = this.modifiablePatientInfo.patientInfo.patientInfoPrimaryDiagnosis;
                              this.patientProps.patientInfo.patientInfoSecondaryDiagnosis = this.modifiablePatientInfo.patientInfo.patientInfoSecondaryDiagnosis;
                              this.patientProps.patientInfo.patientInfoBrainLesion = this.modifiablePatientInfo.patientInfo.patientInfoBrainLesion;
                              this.patientProps.patientInfo.patientInfoOccurrenceDate = this.modifiablePatientInfo.patientInfo.patientInfoOccurrenceDate;
                              this.resetPatientInfo();
                              this.patientInfoSection = 0;
                              this.modifyPatientInfo( this.patientProps );
                              this.$modal.show( 'common-alert-modal', {
                                messageType: 'short',
                                message: 'alert.save_completed'
                              });
                              resolve();
                          } else {
                              reject( '[something] Editing info is failed' );
                          }
                      } )
                      .catch( e => {
                          reject( `[error message] ${e}` );
                      } );
              } );
            },
            editPatientInfo() {
                this.patientInfoSection = 1;
            },
            cancelEditPatientInfo() {
                this.patientInfoSection = 0;
                this.resetModifyPatientInfo();
            },
        },
        computed : {
            reloadPatientProps () {
                let data = Object.assign( {}, data, this.patientProps );
                let patientStatus = {}, patientInfo = {};
                data.patientStatus = Object.assign( {}, patientStatus, this.patientProps.patientStatus );
                data.patientInfo = Object.assign( {}, patientInfo, this.patientProps.patientInfo );
                return data;
            }
        },
        watch : {
            reloadPatientProps : {
                deep : true,
                handler(newData) {
                    this.patientInfo = newData;
                    this.modifiablePatientInfo = JSON.parse(JSON.stringify(newData));
                }
            }
        }
    }
</script>
<style lang="scss">
  .Info {
    display: flex;

    .patient_info_sections {
      flex-grow: 1;
      cursor: auto;
      height: inherit;
      position: relative;
      background: var(--white);
      -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      margin: 5px;
      display: inline-block;
      position: relative;
      padding: 1.5rem;
      overflow-y: auto;
      max-width: 418px;
      min-width: 418px;

      .patient_bottom_btn {
        padding-top: 2rem;
      }

      .title {
        color: var(--blue70);
        font-size: 19px;
        font-weight: bold;
        padding-bottom: .5rem;
      }
    }

    .patient_status_sections {
      flex-grow: 3;
      margin: 5px;
    }
  }
</style>